import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';

export function multiMarkerReseaux(dictionaryMarker, clePosition) {
  dictionaryMarker[clePosition].reseaux = [];
  dictionaryMarker[clePosition].indexReseauCourant = 0;
}

export function typesInformationsReseaux(dictionaryMarker, clePosition, reseau) {
  dictionaryMarker[clePosition].selected = dictionaryMarker[clePosition].selected
    || reseau.selected;
  dictionaryMarker[clePosition].reseaux.push({
    code: reseau.code,
    ville: reseau.ville,
    cp: reseau.cp,
    libelle: reseau.libelle,
    num: reseau.num,
    nbFaces: reseau.nbFaces,
    tarifBrut: reseau.tarifBrutString,
    dureeConservation: reseau.dureeConservation,
    confrere: reseau.confrere,
    jourDepart: reseau.jourDepart,
    jourDepartLibelle: reseau.jourDepartLibelle,
    format: reseau.format,
    selected: reseau.selected,
    urlPhoto: reseau.urlPhoto,
    dispoClass: reseau.dispoClass,
  });

  if (!dictionaryMarker[clePosition].color ||
    dictionaryMarker[clePosition].color === niveauDispo.COULEUR_DISPO_INCONNU) {
    dictionaryMarker[clePosition].color = reseau.couleur;
  }
}



// WEBPACK FOOTER //
// ./src/services/decorateur/decorateurMarkersReseaux.js